/**
 * Etiquetas y estilos de cada tipo de movimiento de entradas.
 * Debe mantenerse alineado con el enum AuditLogType del backend
 * (api/src/modules/audit-logs/entities/audit-log.entity.ts).
 */
export const AUDIT_LOG_TYPES = [
  { value: 'reservation', label: 'Reserva', badge: 'bg-blue-100 text-blue-800' },
  { value: 'sale', label: 'Venta', badge: 'bg-green-100 text-green-800' },
  { value: 'delivery', label: 'Entrega', badge: 'bg-emerald-100 text-emerald-800' },
  { value: 'confirmation', label: 'Confirmación', badge: 'bg-teal-100 text-teal-800' },
  { value: 'completion', label: 'Completada', badge: 'bg-cyan-100 text-cyan-800' },
  { value: 'no_cost', label: 'Sin costo', badge: 'bg-lime-100 text-lime-800' },
  { value: 'return', label: 'Devolución', badge: 'bg-amber-100 text-amber-800' },
  { value: 'return_admin', label: 'Devolución (Admin)', badge: 'bg-orange-100 text-orange-800' },
  { value: 'modification', label: 'Modificación', badge: 'bg-indigo-100 text-indigo-800' },
  { value: 'cancellation', label: 'Cancelación', badge: 'bg-red-100 text-red-800' },
  { value: 'expiration', label: 'Expiración', badge: 'bg-rose-100 text-rose-800' },
  { value: 'deletion', label: 'Eliminación', badge: 'bg-gray-200 text-gray-800' }
];

const TYPE_MAP = AUDIT_LOG_TYPES.reduce((acc, t) => {
  acc[t.value] = t;
  return acc;
}, {});

export const getAuditLogType = (value) =>
  TYPE_MAP[value] || { value, label: value || '—', badge: 'bg-gray-100 text-gray-800' };

// Nombres en español de los estados de reserva (para la columna de transición)
export const RESERVATION_STATUS_LABELS = {
  pending: 'Pendiente',
  blocked: 'Bloqueada',
  confirmed: 'Confirmada',
  sold: 'Vendida',
  delivered: 'Entregada',
  cancelled: 'Cancelada',
  completed: 'Completada',
  returned: 'Devuelta'
};

export const getStatusLabel = (status) =>
  status ? RESERVATION_STATUS_LABELS[status] || status : null;
